import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import axios from 'axios';
import App from '../App.vue';
// import FoodContainer from '../container/food/main-container.vue';
import FoodContainer from '../container/food/food-container.vue';
import FinancialContainer from '../container/financial/financial-container.vue';

let { SSO_USER, LXAnalytics, SSO_CLIENTID } = (window as any);

const Outer = {template: '<router-view></router-view>'};

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: App,
            children: [
                {
                    path: '/',
                    component: FoodContainer,
                },
                {
                    path: 'ces',
                    component: FoodContainer,
                },
                {
                    path: 'normal',
                    component: FoodContainer,
                },
                {
                    path: 'finance',
                    component: FinancialContainer,
                }
            ],
        },
    ]
});
router.beforeEach((to, from, next) => {
    try {
        LXAnalytics(
            'pageView',
            {
                custom: {
                    userMis: window['username'],
                    userName: window['username']
                }
            },
            null,
            to.name
        );
    } catch (e) {
        console.log(e);
    }
    next();
});
export default router;
